import { render, staticRenderFns } from "./reset-confirmation-code.vue?vue&type=template&id=76a185ec&scoped=true"
import script from "./reset-confirmation-code.vue?vue&type=script&lang=js"
export * from "./reset-confirmation-code.vue?vue&type=script&lang=js"
import style0 from "./reset-confirmation-code.vue?vue&type=style&index=0&id=76a185ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a185ec",
  null
  
)

export default component.exports